import { ArrowRightBracketIcon, StyledButton } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { CONTAINED, SUBMIT } from "../../Constants/CommonConstants";
import { LOGIN_BUTTON } from "../../Constants/LoginConstants";

/**
 * @description Displays the Login button
 * @returns {ReactNode} Renders the Login button form to the user
 */
const LoginButton = () => {
  const intl = useIntl();
  return (
    <StyledButton
      variant={CONTAINED}
      fullWidth
      type={SUBMIT}
      id={LOGIN_BUTTON}
      endIcon={<ArrowRightBracketIcon />}
    >
      {intl.formatMessage({ id: LOGIN_BUTTON })}
    </StyledButton>
  );
};

export default LoginButton;
